module.exports = __webpack_public_path__ + "static/aop (3)-bc88e48010a173b9362f78d8dd220cbe.jpg";